





import { Component, Mixins, Vue } from 'vue-property-decorator'
import { initAlipaySource } from '#/api-marketplace/payments'
import { CheckoutInit } from '#/mixins/checkout-init'

@Component
export default class InitAlipaySourcePage extends Mixins(CheckoutInit) {
    async initSession() {
        try {
            const alipaySource = await initAlipaySource(this.orderId)
            // opens alipay checkout
            window.location.href = alipaySource.redirect.url
        } catch (error) {
            console.error(error)
            this.onError()
        }
    }
}
